import api from '@/api_alv'
import { store } from '@/store/store.js'
import i18n from '@/assets/i18n/i18n'
import { DropdownGeneralPeriodTimeUnitsWithUndefined,
         DropdownPublishingWorksStatus,
         DropdownGeneralPeriodTimeUnits,
         DropdownGenericMusicLanguages,
         DropdownAzMetadataLanguages,
        } from '@/assets/dropdowns/alvDropdowns.js'

import { isSet } from 'lodash'

// Cache for context help availability checks (Promise-based to handle concurrent requests)
const contextHelpPromiseCache = {}

export default {
    formatNumberToFourDecimals(number) {
        return number.toLocaleString(i18n.locale, {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
        })
    },
    // Remove dots from the input where dots are used as a thousands separator
    normalizeDecimalFormat(value) {
        if (value) {
            return i18n.locale === 'de' ? value.replaceAll('.', '').replace(',', '.') : value.replaceAll(',', '')
        }
        return value
    },
    /** Extracts the extension of a file name
    * @return {String} file extension */
    extractFileExt(file) {
        if(file !== null && file !== undefined) {
            return file.name.toLowerCase().substr(file.name.lastIndexOf('.') + 1)
        }
    },

    /** Formats the param for "Period" in API Calls, depending on the chosen time unit.
    * @return {String} formatted String */
    buildPeriodStringForApiCall(item, year, number) {
        let period = ''
        if(item === 'notDefined') period += 'period=' + item
        else if(item === 'year') period += 'period=' + item + ',' + year
        else period += 'period=' + number + ',' + item + ',' + year
        return period
    },
    /** Checks a string if it is a lang const for show the right language.
     * @param {String} text string to check */
    isLangConst(text) {
        if(text === null | text === undefined) return ''
        else return text.substring(0,4) === 'lang'
    },

    /** Sets the paging and header-stats informations in the stores.
     * To use these informations from the backend in the frontend,
     * this function will set the informations per list page in the main store.
     * @param {Number} filteredRecords amount of filtered records.
     * @param {Number} currentPage current page. */
    storePagingInformations(filteredRecords, currentPage, totalRecords, numberOfPages = 0) {
        store.commit('setTotalListed', filteredRecords)
        store.commit('setCurrentPage', currentPage)
        store.commit('setTotalRecords', totalRecords)
        store.commit('setNumberOfPages', numberOfPages)
    },

    /** Formats Period from Array to readable String.
     * Use this function to format a period array to a readable String.
     * @param {Array} period
     * @return {String} formatted Period String.
     */
    displayPeriod(period,withUndefined=true) {
        if(period === null) return ''
        if(period.period === null) return ''


        let tempPeriod = ''
        let timeUnitLangConst=''
        period.num === null ? tempPeriod += '' : tempPeriod += period.num + '. '
        if(withUndefined){
            timeUnitLangConst = DropdownGeneralPeriodTimeUnitsWithUndefined.find(element => {
                return element.value === period.period
            }).text
        }else{
            timeUnitLangConst = DropdownGeneralPeriodTimeUnits.find(element => {
                return element.value === period.period
            }).text
        }
        tempPeriod += i18n.t(timeUnitLangConst)
        period.year === null ? '' : tempPeriod += ' ' + period.year

        return tempPeriod
    },

    /** Formats number of seconds to duration String
     * Use this function to format a number of seconds to a readable duration String.
     * @param {Number} seconds
     * @return {String} formatted Duration String.
     */
    transformSecondsToDuration(seconds) {
        if(seconds === null) return ''

        let hours = Math.floor(seconds / 3600)
        seconds = seconds % 3600
        let minutes = Math.floor(seconds / 60)
        seconds = seconds % 60

        let duration = ""

        if (hours) duration += String(hours).padStart(2, '0') + ":"

        duration += String(minutes).padStart(2, '0')  + ":" + String(seconds).padStart(2, '0')

        if(duration === '00:00') return ''
        else return duration
    },

    /** Get Icon Type.
     *  Get the right icon for the given Product type.
     *  Used in invoice rows, e.g. to differentiate Releases and Tracks.
     *  @param {String} type product type.
     *  @return {String} icon name.
     */
    getIconOfType(type) {
        switch (type) {
            case "label/tracks":
                return "graphic_eq"
                break;
            case "label/releases":
                return "album"
                break;
            case "label/freetext":
                return "text_fields"
                break;
            case "publishing/works":
                return "music_note"
                break;
            case "publishing/sheets":
                return "list"
                break;
            case "publishing/releases":
                return "category"
                break;
            case "publishing/freetext":
                return "text_fields"
                break;
            default:
                return ""
                break;
        }
    },

    /** Get the PERSON NAME written in a localized version, especially for japanese and korean settings
     *  format name depends on the formatNameAddress field (asian, european, american)
     *  @param {object} item e.g. object data of person
     *  @return {String} formatted name
     */
    getNameInternational(item) {
        let name = item.name
        if ((item.lastName != null) && item.firstName != null) {
            if (item.formatNameAddress == "japanese" || item.formatNameAddress == "korean") {
                name = item.lastName + ' ' + item.firstName
            } else {
                name = item.firstName + ' ' + item.lastName
            }
        }
        return name
      },

    /** Get the ADDRESS written in a localized version, especially for japanese and korean settings
     *  format address depends on the formatNameAddress field (asian, european, american)
     *  Note: no need to show country if it is the same as the ALV account country, e.g. DE -> do not put Deutschland
     *
     *  @param {object} item e.g. object data of person
     *  @return {String} formatted address
     */
    getAddressInternational(item) {
        let address = ""
        switch(item.formatNameAddress) {
            case "european":
                if(item.inheritFromGroup === true && item.inheritFromGroupObject !== null && item.inheritFromGroupObject !== undefined){
                address =   (item.group         ? item.group + '<br/>' : '') +
                    (item.department    ? item.department + '<br/>' : '' ) +
                    (item.salutation1   ? item.salutation1 + '<br/>' :
                        (item.firstName ? item.firstName : '') + (item.firstName ? ' ' : '') + (item.lastName ? item.lastName + '<br/>' : '')) +
                    (item.inheritFromGroupObject.inv_address   ? item.inheritFromGroupObject.inv_address + '<br/>' : '') +
                    (item.inheritFromGroupObject.inv_address2   ? item.inheritFromGroupObject.inv_address2 + '<br/>' : '' ) +
                    (item.inheritFromGroupObject.inv_zip ? item.inheritFromGroupObject.inv_zip : '') + ' ' + (item.inheritFromGroupObject.inv_city ? item.inheritFromGroupObject.inv_city : '') + '<br/>' +
                    (item.inheritFromGroupObject.inv_land ? this.getTranslatedCountryName(item.inheritFromGroupObject.inv_land) : '')
                }else{
                    address =   (item.group         ? item.group + '<br/>' : '') +
                                (item.department    ? item.department + '<br/>' : '' ) +
                                (item.salutation1   ? item.salutation1 + '<br/>' :
                                    (item.firstName ? item.firstName : '') + (item.firstName ? ' ' : '') + (item.lastName ? item.lastName + '<br/>' : '')) +
                                (item.addressRow1   ? item.addressRow1 + '<br/>' : '') +
                                (item.addressRow2   ? item.addressRow2 + '<br/>' : '' ) +
                                (item.zip ? item.zip : '') + ' ' + (item.city ? item.city : '') + '<br/>' +
                                (item.country ? this.getTranslatedCountryName(item.country) : '')
                }
                break;
            case "japanese":
                if(item.inheritFromGroup === true && item.inheritFromGroupObject !== null && item.inheritFromGroupObject !== undefined){
                    address =   (item.inheritFromGroupObject.inv_zip ? item.inheritFromGroupObject.inv_zip : '') + '<br/>' +
                                (item.state ? item.state : '') + (item.inheritFromGroupObject.inv_city ? item.inheritFromGroupObject.inv_city : '') + ' ' +  (item.inheritFromGroupObject.inv_address   ? item.inheritFromGroupObject.inv_address : '') + '<br/>' +
                                (item.inheritFromGroupObject.inv_address2   ? item.inheritFromGroupObject.inv_address2 + '<br/>' : '' ) +
                                (item.group         ? item.group : '') + ' ' + (item.department ? item.department : '' ) + '<br/>' +
                                (item.salutation1   ? item.salutation1 :
                                    (item.lastName  ? item.lastName : '') + (item.lastName ? ' ' : '') + (item.firstName ? item.firstName : ''))
                }else{
                    address =   (item.zip ? item.zip : '') + '<br/>' +
                                (item.state ? item.state : '') + (item.city ? item.city : '') + (item.addressRow1   ? item.addressRow1 : '') + '<br/>' +
                                (item.addressRow2   ? item.addressRow2 + '<br/>' : '' ) +
                                (item.group         ? item.group : '') + ' ' + (item.department ? item.department : '' ) + '<br/>' +
                                (item.salutation1   ? item.salutation1 :
                                    (item.lastName  ? item.lastName : '') + (item.lastName ? ' ' : '') + (item.firstName ? item.firstName : ''))
                }
                break;
            case "korean":
                if(item.inheritFromGroup === true && item.inheritFromGroupObject !== null && item.inheritFromGroupObject !== undefined){
                    address =   (item.state ? item.state : '') + (item.inheritFromGroupObject.inv_city ? item.inheritFromGroupObject.inv_city : '') + ' ' + (item.inheritFromGroupObject.inv_address   ? item.inheritFromGroupObject.inv_address : '') + '<br/>' +
                                (item.inheritFromGroupObject.inv_address2   ? item.inheritFromGroupObject.inv_address2 + '<br/>' : '' ) +
                                (item.salutation1   ? item.salutation1 :
                                    (item.lastName ? item.lastName : '') + (item.lastName ? ' ' : '') + (item.firstName  ? item.firstName : '')) + '<br/>' +
                                (item.inheritFromGroupObject.inv_zip ? item.inheritFromGroupObject.inv_zip : '')
                }else{

                    address =   (item.state ? item.state : '') + (item.city ? item.city : '') + (item.addressRow1   ? item.addressRow1 : '') + '<br/>' +
                                (item.addressRow2   ? item.addressRow2 + '<br/>' : '' ) +
                                (item.salutation1   ? item.salutation1 :
                                    (item.lastName ? item.lastName : '') + (item.lastName ? ' ' : '') + (item.firstName  ? item.firstName : '')) + '<br/>' +
                                (item.zip ? item.zip : '')
                }
                break;
            case "american":
                if(item.inheritFromGroup === true && item.inheritFromGroupObject !== null && item.inheritFromGroupObject !== undefined){
                    address =   (item.salutation1   ? item.salutation1 :
                                    (item.firstName ? item.firstName : '') + (item.firstName ? ' ' : '') + (item.lastName  ? item.lastName : '')) + '<br/>' +
                                (item.group         ? item.group + '<br/>' : '') +
                                (item.department    ? item.department + '<br/>' : '' ) +

                                (item.inheritFromGroupObject.inv_address   ? item.inheritFromGroupObject.inv_address : '') + '<br/>' +
                                (item.inheritFromGroupObject.inv_address2   ? item.inheritFromGroupObject.inv_address2 + '<br/>' : '' ) +
                                (item.inheritFromGroupObject.inv_city ? item.inheritFromGroupObject.inv_city : '') + ', ' + (item.state ? item.state : '') + ' ' + (item.inheritFromGroupObject.inv_zip ? item.inheritFromGroupObject.inv_zip : '') + '<br/>' +
                                (item.inheritFromGroupObject.inv_land ? this.getTranslatedCountryName(item.inheritFromGroupObject.inv_land) : '')
                }else{
                    address =   (item.salutation1   ? item.salutation1 :
                                    (item.firstName ? item.firstName : '') + (item.firstName ? ' ' : '') + (item.lastName  ? item.lastName : '')) + '<br/>' +
                                (item.group         ? item.group + '<br/>' : '') +
                                (item.department    ? item.department + '<br/>' : '' ) +

                                (item.addressRow1   ? item.addressRow1 : '') + '<br/>' +
                                (item.addressRow2   ? item.addressRow2 + '<br/>' : '' ) +
                                (item.city ? item.city : '') + ', ' + (item.state ? item.state : '') + ' ' + (item.zip ? item.zip : '') + '<br/>' +
                                (item.country ? this.getTranslatedCountryName(item.country) : '')
                }
                break;
            default: // make european format as default
                if(item.inheritFromGroup === true && item.inheritFromGroupObject !== null && item.inheritFromGroupObject !== undefined){
                    address =   (item.group         ? item.group + '<br/>' : '') +
                        (item.department    ? item.department + '<br/>' : '' ) +
                        (item.salutation1   ? item.salutation1 + '<br/>' :
                            (item.firstName ? item.firstName : '') + (item.firstName ? ' ' : '') + (item.lastName ? item.lastName + '<br/>' : '')) +
                        (item.inheritFromGroupObject.inv_address   ? item.inheritFromGroupObject.inv_address + '<br/>' : '') +
                        (item.inheritFromGroupObject.inv_address2   ? item.inheritFromGroupObject.inv_address2 + '<br/>' : '' ) +
                        (item.inheritFromGroupObject.inv_zip ? item.inheritFromGroupObject.inv_zip : '') + ' ' + (item.inheritFromGroupObject.inv_city ? item.inheritFromGroupObject.inv_city : '') + '<br/>' +
                        (item.inheritFromGroupObject.inv_land ? this.getTranslatedCountryName(item.inheritFromGroupObject.inv_land) : '')
                }else{
                    if(item.azType === 'venue') address = (item.name ? item.name + '<br/>' : '')
                    else address =   (item.group         ? item.group + '<br/>' : '')
                    address +=
                        (item.department    ? item.department + '<br/>' : '' ) +
                        (item.salutation1   ? item.salutation1 + '<br/>' :
                            (item.firstName ? item.firstName : '') + (item.firstName ? ' ' : '') + (item.lastName ? item.lastName + '<br/>' : '')) +
                        (item.addressRow1   ? item.addressRow1 + '<br/>' : '') +
                        (item.addressRow2   ? item.addressRow2 + '<br/>' : '' ) +
                        (item.zip ? item.zip : '') + ' ' + (item.city ? item.city : '') + '<br/>'

                    if(item.country !== store.getters.getCompanyCountry) address += (item.country ? this.getTranslatedCountryName(item.country) : '')
                }
                break;
        }

        return address
      },

    /** Get the Product Id of a Track, Label/VÖ, Work, Sheet, Publishing/VÖ
     *  Used in ERP, especially readonly and edit panels of e.g. invoices rows.
     *  @param {object} item e.g. object data of a track incl. ISRC
     *  @return {String} product Id.
     */
    getProductItemId(item) {
        if (item.type != "label/freetext" && item.type != "publishing/freetext") {
            if (item.connectionObject != null) {
                switch (item.type) {
                    case "label/tracks":
                        return this.getProductItemIdLabelTracks(item)
                    case "label/releases":
                        return this.getProductItemIdLabelReleases(item)
                    case "publishing/works":
                        return item.connectionObject.gemaNumber
                    case "publishing/sheets":
                        return item.connectionId
                    case "publishing/releases":
                        return item.connectionId
                    default:
                        break;
                }
            } else { // new row from dialog popup, best to populate all types in .productId
                if (item.isrc != null)
                    return item.isrc
                else if (item.catalogueNumber != null)
                    return item.catalogueNumber
                else if (item.ean != null)
                    return item.ean
                else if (item.productId != null)
                    return item.productId
            }
        }
        return ""
    },

    getProductItemIdLabelReleases(item) {
        // for readonly and editing lists, e.g. in invoices and shipping
        if (item.connectionObject) {
            let ean = item.connectionObject.ean
            let cat = item.connectionObject.catalogueNumber
            if (cat) return cat
                else if (ean) return ean
                else return item.connectionId // ALVID of product, if any (should be)
            } else {
            // for autocomplete dropdown of releases, e.g. in invoiceRow edit dialog
            if (item.alvId.substring(item.alvId.length - 2) == "LR") {
                let ean = item.ean
                let cat = item.catalogueNumber
                if (cat) return cat
                    else if (ean) return ean
                    else return item.alvId // ALVID of product, if any (should be)
            }
        }
    },

    getProductItemIdLabelTracks(item) {
        // for readonly and editing lists, e.g. in invoices and shipping
        if (item.connectionObject) {
            let isrc = item.connectionObject.isrc
            if (isrc)
                return isrc
            else
                return item.connectionObject.alvId
        } else {
            // for autocomplete dropdown of releases, e.g. in invoiceRow edit dialog
            if (item.isrc)
                return item.isrc
            else
                return item.alvId
        }
    },

    /** Get the title of a product.
     *  Used in ERP, especially readonly and edit panels of e.g. invoices and shippin rows.
     *  @param {object} item e.g. object data with/out "connectionObject.title"
     *  @return {String} product title.
     */
    getTitle(item) {
        if (item.connectionObject != null)
            return item.connectionObject.title
        else if (item.title != null)
            return item.title
        else if (item.connectionId && item.type === "label/releases") 
            return item.connectionId  // For releases without connectionObject but with connectionId
        else
            return ""
    },


    /** Combine the role of an Interested Party and its Position
     *  mainly used for Publisher shares enumeration, i.e. E1, E2...etc
     *  @param {String} role e.g. "E"
     *  @param {String} position e.g. "2" or null
     *  @return {String} role-position combination like E1
     */
     getRolePosition(role, position) {
        let str = ''

        if(role !==  null) str += role
        if(position !== null) str += position

        return str
    },

    /** Combine the IPI and ALVID of an Interested Party into a string
     *  mainly used for readonly of Original and Society Shares, i.e. "404053999 | ALV000000793AP"
     *  @param {Object} item e.g. interested party item object
     *  @return {String} IPI | ALVID combination string
     */
    getIpiAlvIdForInterestedParty(item) {
        let str = ''
        if(item.ipi !== '' && item.ipi !== null) {
            str += item.ipi
            if(item.azEntity.alvId !== '' && item.azEntity.alvId !== null) {
                str += ' | ' + item.azEntity.alvId
                return str
            }
        }

        if(item.azEntity.alvId !== '' && item.azEntity.alvId !== null) {
            str += item.azEntity.alvId
            return str
        }
    },

    /**
     * Return a relative path that is used mostly with <router-link> to redirect
     * to other edit page that is related to that ALVID.
     * @param {string} alvid 
     * @return {string} relative path on frontend
     */
    createUrlForAlvId(alvId) {
        if (typeof alvId !== 'string') {
            return null
        }

        if(alvId.includes('AP')) {
            return `/az/azpersons/${alvId}`
        } else if(alvId.includes('AG')){
            return `/az/azgroups/${alvId}`
        } else if(alvId.includes('AD')){
            return `/az/azdistributors/${alvId}`
        }
    },

    /** Get the Icon Tooltip Text.
     *  Get the right tooltip text for a given invoice row icon.
     *  Usually this is the ALVID of the product (not a lang const!).
     *  But if its a freetext row, a special text should be shown
     *  @param {String} object product object with connectionId
     *  @return {String} tooltip text.
     */
    getIconTooltipText(item) {
        // Special cases for items without saved connectionObject but with connectionId
        if (!item.connectionObject && item.connectionId) {
            // Handle tracks
            if (item.type === "label/tracks") {
                return i18n.t('lang_LABEL_CAPTION_TRACK') + " " + item.connectionId
            }
            // Handle releases - use title if available
            else if (item.type === "label/releases") {
                if (item.title) {
                    return i18n.t('lang_LABEL_CAPTION_RELEASE') + ": " + item.title
                } else {
                    return i18n.t('lang_LABEL_CAPTION_RELEASE') + " " + item.connectionId
                }
            }
        }
        
        if (item.connectionObject) {
            let text = (item.connectionId ? item.connectionId : "")
            switch (item.type) {
                case "label/releases":
                    return i18n.t('lang_LABEL_CAPTION_RELEASE') + " " + text
                    break;
                case "label/tracks":
                    return i18n.t('lang_LABEL_CAPTION_TRACK') + " " + text
                    break;
                case "publishing/works":
                    return i18n.t('lang_PUBLISHING_CAPTION_WORK') + " " + text
                    break;
                case "publishing/sheets":
                    return i18n.t('lang_PUBLISHING_CAPTION_SHEET') + " " + text
                    break;
                case "publishing/releases":
                    return i18n.t('lang_PUBLISHING_CAPTION_PROJECT') + " " + text
                    break;
                default:
                    return i18n.t('lang_GENERIC_CAPTION_FREETEXT')
                    break;
            }
        } else {
            return i18n.t('lang_GENERIC_CAPTION_FREETEXT')
        }
    },

    /** Get Society Name.
     *  Get the society name through given society code.
     *  Society code has to be Number without leading zeros.
     *  @param {Number} societyCode society code.
     *  @return {String} society name.
     */
    getSocietyName(societyCode) {
        let societies = store.getters.getSocieties

        if(societyCode === null || societyCode === 0 || societyCode === NaN) return ''
        
        if (!societies || !Array.isArray(societies)) {
            return ''
        }

        const foundSociety = societies.find(society => {
            return society.value === societyCode
        })

        if (foundSociety && foundSociety.text) {
            return foundSociety.text
        } else {
            return ''
        }
    },

    /** Get the country in the selected UI language.
     * The function is matching the countrycode to the right country and
     * returns the name of the country in the selected UI language.
     * If there is no translation for the country it will use EN as fallback language.
     * Update 25.11.2023: return '' if country = HOME COUNTRY
     * Update 21.02.2025: add parameter to return country even if HOME COUNTRY, for A-Z Societies list
     * @param {String} countryCode Country code.
     * @returns {String} country name in selected language.
     */
    getTranslatedCountryName(countryCode, withHomeCountry = false) {

        if(countryCode === null || countryCode === undefined) return ''

        let listOfCountries = store.getters['getCountries' + i18n.locale.toUpperCase()] // get countries from store
        // if we dont have the country names for the selected UI language use EN as fallback
        if (!Array.isArray(listOfCountries)) listOfCountries = store.getters.getCountriesEN
        if (!Array.isArray(listOfCountries)) return ''

        // find the matching country
        let matchingCountry = listOfCountries.find(country => {
            return country.value === countryCode
        })

        // if no match is found return empty string or else return country name
        if(matchingCountry === undefined) return ''
        // if matched country = HOME COUNTRY of account, return empty string
        else {
            if ((matchingCountry.value == store.getters.getUser.companyCountry) && (!withHomeCountry))
                return ''
            else 
                return matchingCountry.text
        }
    },

    /** Get the country in the selected UI language.
     * The function is matching the countrycode to the right country and
     * returns the name of the country in the selected UI language.
     * If there is no translation for the country it will use EN as fallback language.
     * @param {String} countryCode Country code.
     * @returns {String} country name in selected language.
     */
    getTranslatedCountryCode(countryCode){
        if(countryCode === null || countryCode === undefined) return ''

        let listOfCountries = store.getters['getCountries' + i18n.locale.toUpperCase()] // get countries from store
        // if we dont have the country names for the selected UI language use EN as fallback
        if (!Array.isArray(listOfCountries)) listOfCountries = store.getters.getCountriesEN
        if (!Array.isArray(listOfCountries)) return ''

        // find the matching country
        let matchingCountry = listOfCountries.find(country => {
            return country.value === countryCode
        })

        // if no match is found return empty string or else return country name
        if(matchingCountry === undefined) return ''
        // if matched country = HOME COUNTRY of account, return empty string
        else {
            return matchingCountry.text
        }
    },
    /** Get the language in the selected UI language.
     * The function is matching the language code to the right language and
     * returns the name of the language in the selected UI language.
     * If there is no translation for the language it will use EN as fallback language.
     * @param {String} language Language code.
     * @returns {String} language name in selected language.
     */
     getTranslatedLanguageName(languageCode) {
        if(languageCode === null || languageCode === undefined || languageCode === '') return ''

        let matchingLanguage = DropdownAzMetadataLanguages.find(language => {
            return language.value === languageCode.toLowerCase()
        })

        if(matchingLanguage === undefined) return ''
        return i18n.t(matchingLanguage.abbr)
    },

    /** Get list of Generic Music languages for lyrics, translateable and sorted
     * @param {String} Context, i.e. for Publishing > Works remove "Creole"
     * @returns {Array} List of languages
     */
    getListOfGenericMusicLanguages(context) {
        return DropdownGenericMusicLanguages.sort((a,b) => (i18n.t(a.text) > i18n.t(b.text)) ? 1 : (i18n.t(b.text) > i18n.t(a.text)) ? -1 : 0)
    },

    /** Get a list of all countries in the selected UI language.
     *  The function is returning a list of all countries in the selected UI language.
     *  If there is no translation it will use EN as fallback.
     * @returns {Array} List of countries.
     */
    getListOfTranslatedCountries() {
        let countriesArray = []
        let listOfCountries = store.getters['getCountries' + i18n.locale.toUpperCase()] // get countries from store
        // if we dont have the country names for the selected UI language use EN as fallback
        if(listOfCountries === undefined) {
            listOfCountries = store.getters.getCountriesEN
            if(listOfCountries === null || listOfCountries === undefined) return countriesArray
        }

        countriesArray = JSON.parse(JSON.stringify(listOfCountries))
        countriesArray.forEach(country => {
            country['alvqa'] = 'dropdown-country-' + country.value.toLowerCase()
        })

        return countriesArray
    },

    /** Get a list of all languages in the selected UI language.
     *  The function is returning a list of all languages in the selected UI language.
     *  If there is no translation it will use EN as fallback.
     * @returns {Array} List of languages.
     */
    getListOfTranslatedLanguages() {
        let languagesArray = []
        let listOfLanguages = store.getters['getLanguages' + i18n.locale.toUpperCase()] // get languages from store
        // if we dont have the translation of the languages use EN as fallback
        if(listOfLanguages === undefined) {
            listOfLanguages = store.getters.getLanguagesEN
            if(listOfLanguages === null || listOfLanguages === undefined) return languagesArray
        }

        languagesArray = JSON.parse(JSON.stringify(listOfLanguages))
        languagesArray.forEach(language => {
            language['alvqa'] = 'dropdown-language-' + language.value.toLowerCase()
        })

        return languagesArray
    },

    /** Get a list of all Az types for on-screen display
     *  The function is returning a list of all the types associated with the A-Z entry
     *  The types such as "Lager" and "Vertrieb" are currently not translated into EN
     *  It reformats the types from "lager" to a more readable "Lager".
     * @returns {string} String of types.
     */
    getAzTypes(itemTypes) {
        const result = itemTypes.map(element => element.charAt(0).toUpperCase() + element.substring(1).toLowerCase());
        return result.join(', ')
    },

    /** Get a string of selected filters for api call
     *  This function takes an array as a param and loops through it,
     *  to return a string that can be used in the url for api calls.
     *  @param {Object} filterObj filter object.
     *  @return {String} api url filter string.
     */
    createApiUrlFilterString(filterObj) {
        let params = []

        for(let [key, value] of Object.entries(filterObj)) {
            if(value !== '' && value !== null && value.length !== 0 && value !== undefined) {
                params.push(key + '=' + encodeURIComponent(value))
            }
        }

        return params.join('&')
    },

    /** Get a string of selected filters for api call
     *  This function takes an array as a param and loops through it,
     *  to return a string that can be used in the url for api calls.
     *  @param {Object} filterObj filter object.
     *  @return {Object} payload.
     */
    createApiPostFilterString(filterObj) {
        let params = {}

        for(let [key, value] of Object.entries(filterObj)) {
            if(value !== '' && value !== null && value.length !== 0 && value !== undefined) {
                params[key]  = value
            }
        }

        return params
    },

    /** Create a string from the region object.
     *  Region Object must include include and exclude arrays.
     *  @param {Object} regionObject object with include and exclude.
     *  @return {String} returns a string of excluded and included regions.
     */
    createRegionsToString(regionObject) {
        let regions = ''
        const displayCode = (code) => (code === 'WELT' && i18n.locale !== 'de') ? 'WORLD' : code
        
        regionObject.include = regionObject.include || [];
        regionObject.exclude = regionObject.exclude || [];
        
        if(regionObject.include.length !== 0)  {
            let includes = regionObject.include.map(displayCode).join('+')
            regions += includes
        }
        if(regionObject.exclude.length !== 0) {
            regions += '-'
            let excludes = regionObject.exclude.map(displayCode).join('-')
            regions += excludes
        }
        return regions
    },

    /** Format numbers for Dialogs and Panel datatables
     *  Convert a string to use a dot "." as decimal so that i18n recognizes it as a numeral and can format it
     *  BE sends numerical values which are fine for i18n as they come but
     *  FE dialogs need and send strings, to show numbers with comma as decimal sign in German for example
     */
    stringToNumber(item) {
        if (typeof(item) == "string") return parseFloat(item.replace(/,/g, '.'))
            else return item
    },

    stringToFloat(value) {
        if(value === null || value === undefined || value === '') return ''

        // change string to float number
        if (typeof(value) == "string") {
            switch(i18n.locale) {
                case 'en': case 'ko': case 'jp': case 'ja':
                // e.g. "1,000.20"
                    value = parseFloat(value.replace(",",''))
                    break;
                case 'de':
                // e.g. "1.000,20"
                    let tempStr = value.replace(",",'COMMA')
                    tempStr = tempStr.replace(".","")
                    tempStr = tempStr.replace("COMMA",".")
                    value = parseFloat(tempStr)
                    break;
            }
        }
        return value
    },

    floatToString(value) {
        if(value === null || value === undefined || value === '') return ''
        if (typeof(value) == "number") {
            switch(i18n.locale) {
                case 'en': case 'ko': case 'jp': case 'ja':
                    value = new Intl.NumberFormat('en-US',{minimumFractionDigits: 2}).format(value)
                    break;
                case 'de':
                    value = new Intl.NumberFormat('de-DE',{minimumFractionDigits: 2}).format(value)
                    break;
            }
        }
        return value
    },

    /** Numberformatting with i18n.
     * This function checks if the value is null or undefined
     * and converts the value from string to number, if needed.
     * Returns a formatted number.
     * @param {String|Number} value value to be converted.
     * @param {String} type Name of numberformatting, defined in i18n.
     * @returns Formatted String.
     */
    getNumberLocalization(value, type) {
        if(value === null || value === undefined || value === '') return null
        else {
            return i18n.n(this.stringToNumber(value), type)
        }
    },

    /** ISO codes of currencies that are displayed without decimal places (whole numbers).
     *  e.g. JPY (Japanese Yen) has no minor unit. */
    zeroDecimalCurrencies: ['JPY'],

    /** Whether the given currency code is displayed without decimal places.
     *  @param {String} currency ISO currency code (e.g. "JPY", "EUR")
     *  @returns {Boolean} */
    isZeroDecimalCurrency(currency) {
        return this.zeroDecimalCurrencies.includes((currency || '').toUpperCase())
    },

    /** Formats a monetary amount with the correct number of decimals for its currency.
     *  Zero-decimal currencies (e.g. JPY) are shown as whole numbers, all others with 2 decimals.
     *  Defaults to the account's selected currency when none is given.
     *  Mirrors getNumberLocalization: returns null for empty values and accepts string input.
     *  @param {String|Number} value amount to format
     *  @param {String} [currency] ISO currency code; defaults to getSelectedCurrency
     *  @returns {String|null} formatted amount, or null when value is empty */
    formatMoney(value, currency) {
        if(value === null || value === undefined || value === '') return null
        const code = currency || store.getters.getSelectedCurrency
        const type = this.isZeroDecimalCurrency(code) ? 'numberInteger' : 'number'
        return i18n.n(this.stringToNumber(value), type)
    },
    /**Getting the status of the work.
     * The value of status is being passed as a parameter, and returns the text
     * that will be translated.
     * @param {String} dbValue
     * @returns {String} the String variable for Satus that will be translated from the DB
     */
    getStatus(dbValue) {
        return DropdownPublishingWorksStatus.find(status => {
            return status.value === dbValue
        }).text
    },

    /**Checking if the name is defined, not equal to null
     * and is not an empty String
     * @param {Object} item
     * @returns {Boolean}
     */
    printName(item){
        if(item.firstName !== undefined && item.lastName !== undefined &&
            item.firstName !== '' && item.lastName !== '' &&
            item.firstName !== null && item.lastName !== null){
                return true
            }
        return false
    },

    /** Returns the date in ISO Format
     * (Year-Month-Day)
     */
    dateToISOFormat(date) {
        return date.getFullYear() + '-' +
       ('0'+ (date.getMonth()+1)).slice(-2) + '-' +
       ('0'+ date.getDate()).slice(-2)
    },


    /**
     *
     * Returns a list of Societies such as SUISA
     * for CWR export and Distribution Search
     */
    cwrSocieties(withNotASociety, alvqaRoot) {
        let memberSocieties = store.getters.getAzSocietiesWhereDirectMember
        let societies = []

        memberSocieties.forEach(v => {
            if (v.societyCode !== null) {
                societies.push({
                    value: parseInt(v.societyCode),
                    text: v.societyAcronym,
                    alvqa: alvqaRoot + '-' + v.societyAcronym
                })
            }
        });

        // sorting Societies list
        societies.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)

        if (withNotASociety) {
            // Recipient is not a Society aka CWR to be sent to another Publisher (Recipient Code = "000" in CWR filename)
            societies.unshift({text: i18n.t('lang_PUBLISHING_WORKS_EXPORT_NOT_A_SOCIETY'), value: 0, alvqa: alvqaRoot + '-no-society-000' })
        }

        return societies
    },

    /** File import dialog messages shown after processing the file
     *  Example: Works excel import under Publishing > Works > Import > Excel
     *  @param string   dialogCode - this must be a language constant, e.g. lang_PUBLISHING_WORKS_IMPORT_XLSX_ERROR_UVZ_BRACKETS_NOT_CLOSING
     *  @param array    dialogParameters - one or any number of custom parameters, specific to the language constant
     *                  the array keys are the placeholders in the language constant, e.g. <worktitle>, watch out not to use HTML!
     */
    buildDialogMessage(dialogCode, dialogParameters) {
        let messageString = this.buildParameterizedMessage(dialogCode, dialogParameters)
        messageString += '<br /><br />' + i18n.t('lang_GENERAL_DIALOG_TEXT_CLOSE_DIALOG')

        return messageString
    },

    /**
     * Build parameterized message / replace placeholders in language constants
     * @param {string} langConstantName Language constant name which contains placeholders for parameters
     * @param {object} parameters Object which contains key(parameter name)-value(value to put) pairs
     * @returns {string} Generated message filled with parameters
     */
    buildParameterizedMessage(langConstantName, parameters) {
        let messageString = i18n.t(langConstantName)
        if (parameters) {
            for (let key in parameters) {
                messageString = messageString.replace(`<${key}>`, `<b>${parameters[key]}</b>`)
            }
        }

        return messageString
    },

       /**
     *
     * @param {Object} entityDetails
     * In Label => Statistics => In Rows Dropdown there is a list of Distributors that we get from local storage.
     * This list consists of A-Z Distributors that are set as visible and A-Z Persons and A-Z Groups entities
     * that have "Kommissionsvertrieb" or "Vertrieb" as type and set as visible.
     *
     * Method updates the local storage information if entity from A-Z Groups/Distributors/Persons
     * was set to visible/invisible
     */
        updateListOfDistributorsInLocalStorageAccordingToEntity(entityDetails){
            /**
             * Declaring:
             *  - Local Storage Object
             *  - Details of the saved entity (A-Z Groups or A-Z Persons)
             *  - Array of entity types
             *  - List of distributors sent from BE to Local Storage
             */
            let savedEntityDetails = entityDetails
            let savedEntityTypesArray = entityDetails.type
            let localStorageData = JSON.parse(localStorage.getItem("userData"))
            let distributorsListFromLS = localStorageData.labelStatisticsInRows.distributors

            if(savedEntityTypesArray !== null){
                // Checking if entity types array has a type "Vertrieb" or "Kommissionsvertrieb"
                let entityHasTypeDistributor = savedEntityTypesArray.includes('vertrieb');
                let entityHasTypeComissionDistributor = savedEntityTypesArray.includes('kommissionsvertrieb');

                //If the entity has type of vertrieb, or kommissionsvertrieb or both selected then do the following:
                if((entityHasTypeDistributor || entityHasTypeComissionDistributor) || entityHasTypeComissionDistributor && entityHasTypeDistributor){
                    // Case 1: If the visibility of the entity was "hidden" and changed to "visible"
                    if(savedEntityDetails.visibility === 2){
                        //Searching for previously saved entity in the list of visible distributors in Local Storage
                        let matchVisible = distributorsListFromLS.find(distributor => {
                            return distributor.alvid === savedEntityDetails.alvId
                        })

                        //If the saved entity was found nothing will be done
                        if(matchVisible !== undefined && matchVisible !== null){
                            return
                        }else{
                            /**
                             *   Otherwise:
                             *      - Entity was not in the list that was sent from BE to Local Storage
                             *      - Creating a new object with the required data for the distributors list in Local storage
                             *      - Pushing new Object (visible entity) to the list of visible distributors in Local Storage
                             *      - Updating the local storage information
                             *
                             * */

                            let newObj = {
                                value: savedEntityDetails.id,
                                text: savedEntityDetails.group,
                                alvid: savedEntityDetails.alvId
                            }
                            localStorageData.labelStatisticsInRows.distributors.push(newObj)
                            localStorage.setItem("userData",JSON.stringify(localStorageData))

                        }
                    }else
                    // Case 2: If the visibility of the entity was changed to "hidden"
                    {
                        //Searching for an saved entity in the list of visible distributors in local Storage
                        let matchHidden = distributorsListFromLS.find(distributor => {
                            return distributor.alvid === savedEntityDetails.alvId
                        })

                        /**
                         * If the enity was found in the list of distributors in Local Storage:
                         *  - Finding index of the newly saved enity in the list of distributors in Local Storage
                         *  - Removing the enity from the list of visible distributors in Local Storage
                         *  - Updating the information in Local Storage
                         */
                        if(matchHidden !== undefined && matchHidden !== null){

                            let indexOfDistributorToRemove = localStorageData.labelStatisticsInRows.distributors.findIndex(distributor =>{
                                return distributor.alvid === matchHidden.alvid
                            })
                            localStorageData.labelStatisticsInRows.distributors.splice(indexOfDistributorToRemove,1)
                            localStorage.setItem("userData",JSON.stringify(localStorageData))

                        }else{
                            //The distributor with the Visibility status "Hidden" was not in the list of visible distributors in Local Storage
                            // => Do nothing
                            console.log("Hidden: Was not found");
                        }
                    }
                }else{
                    /**
                     * For the case if:
                     *  - the the entity type "vertrieb" and "kommissionsvertrieb" were removed
                     *  - the entity was saved
                     *  - entity is still in the list of distributors from LS
                     */

                    //Find the entity in the list of distributors in local storage
                    let matchVisible = distributorsListFromLS.find(distributor => {
                        return distributor.alvid === savedEntityDetails.alvId
                    })
                    /**
                     * - Removing found entity from the list of distributors
                     * - Updating the information in local storage
                     */
                    if(!entityHasTypeDistributor && !entityHasTypeComissionDistributor && matchVisible){
                        let indexOfDistributorToRemove = localStorageData.labelStatisticsInRows.distributors.findIndex(distributor =>{
                            return distributor.alvid === matchVisible.alvid
                        })
                        localStorageData.labelStatisticsInRows.distributors.splice(indexOfDistributorToRemove,1)
                        localStorage.setItem("userData",JSON.stringify(localStorageData))
                    }
                }
            }
        },

        /**
         * Get the correct "name" of a AZ Entity (group or person).
         * To return only the Group name from A-Z Person entry (without first/lastname)
         * set the 2nd parameter "groupNameAlone" to true in the calling function 
         */
        showNameOfAzEntry(azEntity, groupNameAlone = false) {
            if (!azEntity || azEntity == null) {
                return ""
            }
            let name = ""
            if (azEntity.typeOfAz) {
                let azType = azEntity.typeOfAz
                switch(azType) {
                    case 'G':
                        if(azEntity.group !== null) name = azEntity.group
                        else name = azEntity.gemaName
                        break
                    case 'P':
                        if(azEntity.group !== null) {
                            name = azEntity.group
    
                            if ((azEntity.firstName !== null || azEntity.lastName !== null) && (!groupNameAlone)) {
    
                                name += ' (' + (azEntity.firstName !== null ? azEntity.firstName : '') + (azEntity.lastName !== null ?  ' ' + azEntity.lastName : '')   + ')'
                            }
    
                        }
                        else if(azEntity.firstName !== null || azEntity.lastName !== null) name = (azEntity.firstName !== null ? azEntity.firstName : '') + (azEntity.lastName !== null ?  ' ' + azEntity.lastName : '')
                        else name = azEntity.gemaName
                        break
                    case 'D':
                        if(azEntity.group !== null) name = azEntity.group
                        else name = azEntity.gemaName
                        break
                    default:
                        name = azEntity.gemaName
                }
            } else {
                // case of A-Z Society is assumed here
                name = azEntity.societyAcronym
            }
            return name
        },
        /**
         * In order to show Artist/Performer correctly (legacy data = just strings or az entity object)
         * we have to check if the artist/performer is a string or object and
         * then get the correct name to show depending on the az type.
         * @param azEntity
         */
        getArtistOrPerformerName(azEntity) {
            if(azEntity !== null && azEntity !== undefined) {
               if (typeof azEntity  === 'object' && !Array.isArray(azEntity)) return this.showNameOfAzEntry(azEntity, true)
               else return azEntity
            } else {
                return null
            }
        },

        /**
         *
         * @returns country from Account => Companies
         *
         * Method is automatically setting up a country in A-Z Persons & Groups
         * according to the country from Account => Companies.
         *
         * If country in Account => Companis is defined, this country will be set up automatically
         * when creating a new A-Z Group or Person. Otherwise the field country in A-Z Group or Person
         * will be left empty and user will have to define the country by himself.
         */

        setCountryInAzGroupsAndPersons(){
            let country = ''
            let companyCountry = JSON.parse(localStorage.getItem("userData"))['user']['companyCountry']

            if(companyCountry !== undefined && companyCountry !== null && companyCountry !== ""){
                country = companyCountry
            }
            return country
        },
        /**
         * 
         * @param {Object} objectOfOriginalShares 
         * @returns sorted array of original interested parties sorted by role
         */
        sortingOriginalInterestedPartiesByRole(objectOfOriginalShares){
            let sortedObjectOfOriginalShares = {}
            /**
             * Separate Arrays for each role type is created
             * in order to create a needed sorting hierarchy which is:
             * C => CA => AR => A => TS => SA => TNA => TNE => ST => SE => E
             */
            Object.entries(objectOfOriginalShares).forEach(([key, listOfOriginalShares]) => {
                let sortedListOfOriginalShares = []

                let arrayC = []
                let arrayCA = []
                let arrayA = []
                let arrayAR = []
                let arrayE = []
                let arraySE = []
                let arraySA = []
                let arrayTNA = []
                let arrayTNE = []
                let arrayTS = []
                let arrayST = []
                let arraySR = []
                if(listOfOriginalShares.length !== 0){

                    for (const share of Array.from(listOfOriginalShares)) {
                        if(share.role === "C"){
                            arrayC.push(share) 
                        }else if(share.role === "CA"){
                            arrayCA.push(share) 
                        }else if(share.role === "A"){
                            arrayA.push(share) 
                        }else if(share.role === "AR"){
                            arrayAR.push(share) 
                        }else if(share.role === "E"){
                            arrayE.push(share) 
                        }else if(share.role === "SE"){
                            arraySE.push(share) 
                        }else if(share.role === "SA"){
                            arraySA.push(share) 
                        }else if(share.role === "TNA"){
                            arrayTNA.push(share) 
                        }else if(share.role === "TNE"){
                            arrayTNE.push(share) 
                        }else if(share.role === "TS"){
                            arrayTS.push(share) 
                        }else if(share.role === "ST"){
                            arrayST.push(share)
                        }else if(share.role === "SR"){
                            arraySR.push(share)
                        }      
                    }
                }

                sortedListOfOriginalShares = sortedListOfOriginalShares.concat(arrayC,arrayCA,arrayAR,arraySR,arrayA,arrayTS,arraySA,arrayTNA,arrayTNE,arrayST,arraySE,arrayE) 
                sortedObjectOfOriginalShares[key] = sortedListOfOriginalShares
            })

            return sortedObjectOfOriginalShares
        },

        getSocietyPanelHeadline(societyCode) {
            if (societyCode === null) return '';
            
            const parsedCode = parseInt(societyCode)
            const societyName = this.getSocietyName(parsedCode)
            
            return societyName + '-' + i18n.t('lang_GENERAL_CAPTION_SHARES')
        },
        getTodaysDateYYYYMMDD () {
            var today = new Date();
            
            // Extract year, month, and day
            var year = today.getFullYear();
            var month = (today.getMonth() + 1).toString().padStart(2, '0');
            var day = today.getDate().toString().padStart(2, '0');
            
            // Format the date as 'YYYY-MM-DD'
            return year + '-' + month + '-' + day;
        },

        /** "Bemerkung" label for the A-Z Other IDs (Abrechnungsquelle) autocomplete + table.
         * A statement source is always a whole A-Z entry, so only its name is shown, never a contract (ALVCODE-1537).
         * Looks at the row itself first, then at `row.personObject` as fallback.
         * @param {Object} source autocomplete row OR a saved OtherIds row
         * @return {String} display label for the Bemerkung column / autocomplete entry */
        getOtherIdsRoleLabel(source) {
            if (!source || typeof source !== 'object') return ''
            const person = source.personObject && typeof source.personObject === 'object' ? source.personObject : {}
            return source.gemaName || source.name || person.gemaName || person.name || ''
        },

        /** Checks if context help content is available for a given context
         * Uses Promise caching to prevent duplicate concurrent API calls
         * @param {String} context - The context identifier for help content
         * @return {Boolean} true if help content is available, false otherwise */
        async checkContextHelpAvailability(context) {
            // Return cached promise if available (handles both pending and resolved)
            if (contextHelpPromiseCache[context]) {
                return contextHelpPromiseCache[context]
            }
            
            // Create and cache the promise BEFORE awaiting
            contextHelpPromiseCache[context] = (async () => {
                try {
                    // Always check German - if DE article exists, show help icon.
                    // The ContextHelpDialog handles fallback for other languages.
                    const response = await api.fetchContextHelp(context, null, 'de')
                    return response && response.length > 0
                } catch (error) {
                    return false
                }
            })()
            
            return contextHelpPromiseCache[context]
        }
}
